import React from 'react';
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend,ResponsiveContainer } from 'recharts';
//import time from '../../times.json'

import CustomToolkit from './CustomToolkit'

const UptimeGraph = ({times,choice}) => {

  //if the user chooses to view status in past 24 hours 
  if(choice==24){
      const currentTime = new Date().getTime(); // current timestamp in milliseconds
      var time = times.filter(entry => {
        const entryTime = new Date(`${entry.date} ${entry.time}`).getTime(); // convert entry date and time to timestamp
        
        return currentTime - entryTime <= 24 * 60 * 60 * 1000; // filter entries from the last 24 hours
      });
  }
  //if the user chooses to view status in past 7 days
  if(choice==7*24){
    const currentTime = new Date().getTime(); // current timestamp in milliseconds
    var time = times.filter(entry => {
      const entryTime = new Date(`${entry.date} ${entry.time}`).getTime(); // convert entry date and time to timestamp
      
      return currentTime - entryTime <= 7*24 * 60 * 60 * 1000; // filter entries from the last 24 hours
    });
  }
  //if the user chooses to view status in past 30 days
  if(choice==30*24){
    const currentTime = new Date().getTime(); // current timestamp in milliseconds
    var time = times.filter(entry => {
      const entryTime = new Date(`${entry.date} ${entry.time}`).getTime(); // convert entry date and time to timestamp
     
      return currentTime - entryTime <= 30*24 * 60 * 60 * 1000; // filter entries from the last 24 hours
    });
  }
  return (
    <div>
      <ResponsiveContainer width="100%" height={100}>
    <BarChart
      
      data={time}
      // backgroundColor= 'red'
      margin={{
        top: 5,
        right: 40,
        left: -10,
        bottom: 5
      }}
    >
      {/* <CartesianGrid strokeDasharray="3 3" /> */}
      <XAxis dataKey="time" display="none" />
      <YAxis yAxisId="left" display="none" />
      <Tooltip content={<CustomToolkit/>} />
      
      <Bar yAxisId="left" dataKey="h"  boxSize={50} radius={[10, 10, 10, 10]} >
     
       		{
          	time.map((entry, index) => {
            	const color = entry.status === 'true' ? '#32CD32' :'red';
            	return <Cell fill={color} />;
            })
          }
      </Bar>
    </BarChart>
    </ResponsiveContainer>
    </div>
  );
};

export default UptimeGraph;
